export const resetStore = () => {
  return {
    type: "RESET_APP",
  };
};
